import { all, fork } from "redux-saga/effects";

import conciliated from "./conciliated";
import pending from "./pending";
import user from "./user";
import files from "./files";
import clients from "./clients";
import automatic from "./automatic";
import detail from "./detail";

export default function* root() {
  yield all([
    fork(conciliated),
    fork(pending),
    fork(automatic),
    fork(user),
    fork(files),
    fork(clients),
    fork(detail)
  ]);
}
